import React from 'react';
import styled, { css } from 'styled-components';
import { COLORS, SPACINGS } from '../app/common/constants/styles';
import ICONS from '../app/common/constants/icons';
import Icon from '../app/common/components/Icon';
import { services } from './BuContent';
import { TranslationHelpers } from '../i18n/translationHelpers';

const List = styled.ul`
    list-style: none;
    padding: 0;
    margin: 10px 0px;
`;

const NameIcon = styled.div<{ styles: any }>`
    display: flex;
    align-items: center;
    width: 90%;
    padding: 20px;
    border-radius: 35px;
    justify-content: space-between;
    max-height: 65px;
    ${(props) => (props.styles ? props.styles : '')};

    & span {
        margin-left: 15px;
        color: ${COLORS.white};
        font-size: 16px;
    }
`;

const ListItem = styled.li`
    border-radius: 5px;
    background-color: transparent;
`;

const ListItemLink = styled.a`
    text-decoration: none;
    padding: ${SPACINGS.base * 1}px 0;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const BuLogoImage = styled.img<{ localStyles: any }>`
    height: 25px;
    ${(props) => (props.localStyles ? props.localStyles : '')}
`;

const rakutenFranceStyles = css`
    height: 40px;
    margin-left: -10px;
    margin-bottom: 9px;
`;

const BuVerticalTiles = (props: any) => {
    return (
        <List>
            {props.buContent.map((bu: Record<string, any>) => {
                if (bu.id !== services.CROP) {
                    let style = { background: bu.backgroundColor };
                    return (
                        <ListItem key={bu.id}>
                            <ListItemLink
                                href={bu.links[0].link}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <NameIcon styles={style}>
                                    <BuLogoImage
                                        localStyles={
                                            bu.id === services.FRANCE ? rakutenFranceStyles : null
                                        }
                                        src={bu.logo.white}
                                        alt={bu.alt}
                                    />
                                    <span>{bu.links[0].siteText}</span>
                                </NameIcon>
                                <Icon icon={ICONS.ARROW_RIGHT} size={'18'} />
                            </ListItemLink>
                        </ListItem>
                    );
                } else return null;
            })}
            {props.buContent.map((bu: Record<string, any>) => {
                if (bu.id === services.CROP) {
                    let style = { background: bu.backgroundColor };
                    return bu.links.map((record: Record<string, string>, index: number) => {
                        return (
                            <ListItem key={record.siteText + '_' + index}>
                                <ListItemLink
                                    href={record.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <NameIcon styles={style}>
                                        <BuLogoImage
                                            localStyles=""
                                            src={`${bu.logo.white}`}
                                            alt={bu.alt}
                                        />
                                        <span>
                                            {TranslationHelpers.getFormattedMessage(record.name)}
                                            {' - '}
                                            {TranslationHelpers.getFormattedMessage(
                                                record.siteText,
                                            )}
                                        </span>
                                    </NameIcon>
                                    <Icon icon={ICONS.ARROW_RIGHT} size={'18'} />
                                </ListItemLink>
                            </ListItem>
                        );
                    });
                } else return null;
            })}
        </List>
    );
};

export default BuVerticalTiles;
